import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '@backstage/core-app-api';
import { visitsApiRef } from '../api/VisitsApi.esm.js';
import { useApi } from '@backstage/core-plugin-api';
import { stringifyEntityRef } from '@backstage/catalog-model';

const getToEntityRef = ({
  rootPath = "catalog",
  stringifyEntityRefImpl = stringifyEntityRef
} = {}) => ({ pathname }) => {
  const regex = new RegExp(
    `^/${rootPath}/(?<namespace>[^/]+)/(?<kind>[^/]+)/(?<name>[^/]+)`
  );
  const result = regex.exec(pathname);
  if (!result || !result?.groups)
    return void 0;
  const entity = {
    namespace: result.groups.namespace,
    kind: result.groups.kind,
    name: result.groups.name
  };
  return stringifyEntityRefImpl(entity);
};
const getVisitName = ({ rootPath = "catalog", document = global.document } = {}) => ({ pathname }) => {
  const regex = new RegExp(
    `^/${rootPath}/(?<namespace>[^/]+)/(?<kind>[^/]+)/(?<name>[^/]+)`
  );
  let result = regex.exec(pathname);
  if (result && result?.groups)
    return result.groups.name;
  result = /^\/(?<name>[^\/]+)$/.exec(pathname);
  if (result && result?.groups)
    return result.groups.name;
  return document.title;
};
const VisitListener = ({
  children,
  toEntityRef,
  visitName
}) => {
  const visitsApi = useApi(visitsApiRef);
  const { pathname } = useLocation();
  const toEntityRefImpl = toEntityRef ?? getToEntityRef();
  const visitNameImpl = visitName ?? getVisitName();
  useEffect(() => {
    const requestId = requestAnimationFrame(() => {
      visitsApi.save({
        visit: {
          name: visitNameImpl({ pathname }),
          pathname,
          entityRef: toEntityRefImpl({ pathname })
        }
      });
    });
    return () => cancelAnimationFrame(requestId);
  }, [visitsApi, pathname, toEntityRefImpl, visitNameImpl]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};

export { VisitListener };
//# sourceMappingURL=VisitListener.esm.js.map
